export function getRange(values: number[], buffer: number, expandZeroVariance: boolean = true) {
  if (values.length == 0) return [0, 1];
  if (values.length == 1) return expandZeroVariance ? [values[0] - 1, values[0] + 1] : [values[0], values[0]];
  let minV = 1e99;
  let maxV = -1e99;
  for (const val of values) {
    if (minV > val) minV = val;
    if (maxV < val) maxV = val;
  }
  if (maxV == minV) {
    return expandZeroVariance ? [minV - 1, maxV + 1] : [minV, maxV];
  }
  return [minV - (maxV - minV) * buffer, maxV + (maxV - minV) * buffer];
}

export function getAxisDef(rangeMin: number, rangeMax: number, estimTickCount: number) {
  if (rangeMax <= rangeMin) return [];
  const tickVariants = [
    {
      minorStep: 1,
      majorFactor: 5,
    },
    {
      minorStep: 2,
      majorFactor: 5,
    },
    {
      minorStep: 5,
      majorFactor: 4,
    },
  ];
  const optimMajorDist = (rangeMax - rangeMin) / estimTickCount;
  const estimMagnitude = Math.round(Math.log10(optimMajorDist));
  let minErrorValue = 1e99;
  let choiceTickVariant = null;
  let choiceMagnitudeFactor = 1;
  let choiceMagnitude = 0;
  for (let tryMagnitude = estimMagnitude - 1; tryMagnitude <= estimMagnitude + 1; tryMagnitude++) {
    const tryMagnitudeFactor = 10 ** tryMagnitude;
    for (const tryTickVariant of tickVariants) {
      const tryMajorDist = tryTickVariant.minorStep * tryTickVariant.majorFactor * tryMagnitudeFactor;
      const tryErrorValue =
        tryMajorDist > optimMajorDist ? tryMajorDist / optimMajorDist : optimMajorDist / tryMajorDist;
      if (tryErrorValue < minErrorValue) {
        choiceTickVariant = tryTickVariant;
        choiceMagnitudeFactor = tryMagnitudeFactor;
        choiceMagnitude = tryMagnitude;
        minErrorValue = tryErrorValue;
      }
    }
  }
  if (!choiceTickVariant) return [];
  const minorTickDist = choiceTickVariant!.minorStep * choiceMagnitudeFactor;
  const majorTickFactor = choiceTickVariant!.majorFactor;
  let precision = -choiceMagnitude;
  if (choiceTickVariant!.minorStep * choiceTickVariant!.majorFactor >= 9.99999) precision--;
  if (precision < 0) precision = 0;
  const rs: any[] = [];
  for (let posit = Math.floor(rangeMin / minorTickDist) * minorTickDist; posit <= rangeMax; posit += minorTickDist) {
    let label = null;
    if (Math.round(posit / minorTickDist) % majorTickFactor == 0) {
      label = posit.toFixed(precision);
      if (Math.abs(posit) > 1e4) label = posit.toExponential();
    }
    rs.push({
      posit,
      label,
    });
  }
  return rs;
}
